let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("egrVC")).then(() => parcelRequire('lJOkF'));